import { render, staticRenderFns } from "./ValueTreeFieldType2.vue?vue&type=template&id=8f621d7c&scoped=true"
import script from "./ValueTreeFieldType2.vue?vue&type=script&lang=js"
export * from "./ValueTreeFieldType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f621d7c",
  null
  
)

export default component.exports